export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`/api${path}`, {
    credentials: 'include',
    ...init,
    headers: {
      ...(init?.body && !(init.body instanceof FormData) ? { 'Content-Type': 'application/json' } : {}),
      ...init?.headers,
    },
  });
  if (response.status === 204) return undefined as T;
  const payload = await response.json() as { error?: { message?: string } } & T;
  if (!response.ok) throw new Error(payload.error?.message ?? 'Permintaan gagal. Silakan coba lagi.');
  return payload;
}

export type AcademicYear = { id: string; label: string };
export type Page<T> = { items: T[]; pagination: { page: number; pageSize: number; total: number } };
